import * as React from "react";
import CreateService from "../../service/create";
import PopDetail from "../popdetail";
import ReadService from "../../service/read";
import Wait from "../wait";

export default class AddNewDeedPlan extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            project_type: {value: 0},
            project_init:{value:0},
            villages:[]
        }
        this.loadData = this.loadData.bind(this)
        this.submit = this.submit.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
    }


    componentDidMount() {
        this.loadData()
    }

    handleChanges=(e)=>{
        this.setState({[e.target.name]:e.target.value})
    }


    render() {
        return(<div className={'row'}>

            <div className={'col col-sm-12'} style={{padding:0}}>

                <div style={{padding: '16px', background: '#efefef', position: 'sticky', top: 0, zIndex: 2,display:'none'}}>
                     <span style={{fontSize: '16px'}}>
                        <span className={'fa fa-users'} style={{marginRight: '8px'}}/>
                        Project Initiation
                    </span>

                    <span style={{fontSize: '12px', float: 'right'}}>
                        <span className={'fa fa-history'} style={{marginRight: '11px', marginLeft: '4px'}}/>Updated 28 Minutes Ago
                    </span>

                </div>

                <table style={{width:'94%',margin:'2%'}}>
                    <tbody>

                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Deed Plan Name</td>
                    </tr>
                    <tr>
                        <td>
                            <input type={'text'} style={{width:'98.6%',padding:'8px'}} name={'name'} onChange={this.handleChanges}/>
                        </td>
                    </tr>

                    <tr>
                        <td className={'label'} style={{width:'100%'}}>Village</td>
                    </tr>
                    <tr>
                        <td>
                            <select style={{width:'100%'}} onChange={this.handleChanges} name={'village'}>
                                <option value={0}>- Choose One -</option>
                                {this.state.villages.map((d,i)=>{
                                    return(<option value={d.id} key={i}>{d.label}</option>)
                                })}
                            </select>
                        </td>
                    </tr>
                    <tr>
                         <td className={'label'} style={{width:'100%'}}>Projection ( SRID )</td>
                    </tr>
                    <tr>
                        <td>
                             <select style={{width:'100%'}} onChange={this.handleChanges} name={'srid'}>
                                <option value={0}>- Choose One -</option>
                                 <option>32737</option>
                                 <option>32736</option>
                                 <option>4326</option>
                            </select>
                        </td>
                    </tr>

                    </tbody>
                </table>

                <div style={{textAlign:'center',width:'100%',float:'left'}}>
                    <button className={'btn submit'} onClick={this.submit}>
                        <span className={'fa fa-save'}/>Save
                    </button>
                     <button className={'btn error'} onClick={()=>PopDetail.dismiss()}>
                        <span className={'fa fa-times'}/>Close
                    </button>
                </div>

            </div>

        </div>)
    }

    loadData(){

        try{
            Wait.show('Fetching Villages....')
            ReadService.fetchProjectVillages(this.props.project.id).then(r => {
                Wait.dismiss()
                this.setState({
                    villages:r.data.results
                })
            })
        }catch (e) {
            console.log(e)
        }

        //console.log('here,...')
        //console.log(this.props.project)
    }


    submit(){
        try{

            let name = this.state.name
            let village = parseInt(this.state.village)
            let srid = parseInt(this.state.srid)

            if (name.length<2){
                alert('Invalid Name')
                return
            }
            if (village<1){
                alert('Invalid Village')
                return;
            }
             if (srid<1){
                 alert('Invalid SRID')
                return;
            }

             Wait.show('Creating Deed plan....')
             CreateService.createDeedPlan({
                 name:name,
                 villageId:village,
                 srid:srid,
                 project:this.props.project.id
             }).then(r =>{
                 Wait.dismiss()
                 PopDetail.dismiss()
                 this.props.loadData()
             })

        }catch (e) {
             alert(e)
        }
    }


}